/* Shared across BeeGo sections. Does not change Shopify Markets or call a geo API. */
(() => {
  if (window.BeeGoMarketplace) { window.BeeGoMarketplace.refresh(); return; }
  const key = 'beego-buying-country-v1';
  const europe = new Set('AD AL AT AX BA BE BG BY CH CY CZ DE DK EE ES FI FO FR GG GI GR HR HU IM IS IT JE LI LT LU LV MC MD ME MK MT NL NO PL PT RO RS RU SE SI SJ SK SM UA VA XK'.split(' '));
  let selected;
  try { selected = JSON.parse(localStorage.getItem(key)); } catch (_) {}
  const valid = value => value && /^[A-Z]{2}$/.test(value.code) && typeof value.name === 'string' && typeof value.continent === 'string';
  if (!valid(selected)) selected = null;
  function market(country) {
    if (country.code === 'US') return {key:'us', label:'US', region:'the US'};
    if (country.code === 'IE') return {key:'ie', label:'Ireland', region:'Ireland'};
    if (country.code !== 'IE' && country.code !== 'GB' && (country.continent === 'Europe' || europe.has(country.code))) return {key:'de', label:'Germany', region:country.code === 'DE' ? 'Germany' : 'Europe'};
    return {key:'uk', label:'UK', region:'the UK'};
  }
  function detected() {
    const el = document.querySelector('[data-beego-country]');
    return {code:el?.dataset.countryCode || 'GB',name:el?.dataset.countryName || 'United Kingdom',continent:el?.dataset.countryContinent || ''};
  }
  function refresh() {
    const country = selected || detected(), m = market(country);
    document.querySelectorAll('[data-beego-amazon]').forEach(el => {
      const link = el.querySelector('[data-beego-link]'), coming = el.querySelector('[data-beego-coming]');
      if (!link || !coming) return;
      const url = (el.getAttribute('data-amazon-'+m.key) || '').trim();
      link.hidden = !url; coming.hidden = !!url;
      if (url) {
        link.href = url;
        link.textContent = 'View on Amazon '+m.label+' ↗';
        link.setAttribute('aria-label','View '+(el.closest('[data-product-name]')?.dataset.productName || 'product')+' on Amazon '+m.label+' (opens in a new tab)');
      } else link.removeAttribute('href');
      coming.textContent = 'Coming soon to '+m.region;
    });
    document.querySelectorAll('[data-beego-country]').forEach(select => {
      let option = Array.from(select.options).find(o => o.value === country.code);
      if (!option) {
        option = new Option(country.name, country.code); option.dataset.continent = country.continent; select.add(option);
      }
      select.value = country.code;
    });
    document.querySelectorAll('[data-beego-market-status]').forEach(el => {el.textContent = 'Product links use Amazon '+m.label+'.';});
  }
  document.addEventListener('change', e => {
    if (!e.target.matches('[data-beego-country]')) return;
    const option = e.target.selectedOptions[0];
    selected = {code:option.value,name:option.textContent,continent:option.dataset.continent || ''};
    try { localStorage.setItem(key,JSON.stringify(selected)); } catch (_) {}
    refresh(); document.dispatchEvent(new CustomEvent('beego:country-change',{detail:selected}));
  });
  window.addEventListener('storage',e => {if(e.key===key){try{selected=JSON.parse(e.newValue)}catch(_){selected=null}if(!valid(selected))selected=null;refresh();}});
  document.addEventListener('shopify:section:load',refresh);
  window.BeeGoMarketplace = {refresh, market, getCountry:()=>selected || detected()};
  refresh();
})();
